import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(theme => {
  const { semanticColor, borderRadius } = theme;
  return {
    iconBackground: () => ({
      background: semanticColor.warning,
      'border-radius': borderRadius.large,
      height: '70px',
      width: '70px',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
    }),
  };
});

export default useStyles;
